<template>
  <div class="language-switcher">
    <button
        class="language-switcher__button"
        @click="toggleVisibility"
        @blur="handleBlur"
    >
      {{ currentLocale.toUpperCase() }}
    </button>
    <transition name="dropdown-fade">
      <ul
          v-if="isVisible"
          ref="dropdown"
          class="language-switcher__dropdown"
      >
        <li v-for="(lang, idx) in langs" :key="idx">
          <a
              href="#"
              class="language-switcher__item"
              :class="{ 'language-switcher__item--active': lang.shortName === currentLocale }"
              @click.prevent="setLocale(lang.shortName)"
          >
            <span>{{ lang.localName }}</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "LanguageSwitcher",
  data() {
    return {
      isVisible: false,
      langs: [
        {
          shortName: "ru",
          longName: "Russian",
          localName: "Русский"
        },
        {
          shortName: "en",
          longName: "English",
          localName: "English"
        },
        {
          shortName: "es",
          longName: "Spanish",
          localName: "Español"
        },
        {
          shortName: "fa",
          longName: "Persian",
          localName: "فارسی"
        },
        {
          shortName: "fr",
          longName: "French",
          localName: "Français"
        }
      ]
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    ...mapActions(['getCourses', 'getCategories']),
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    handleBlur() {
      // Закрываем dropdown если клик был вне компонента
      setTimeout(() => {
        if (!this.$el.contains(document.activeElement)) {
          this.isVisible = false;
        }
      }, 200);
    },
    async setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("lang", locale);
      // Перезагружаем курсы и категории с новым языком
      await Promise.all([
        this.getCourses(),
        this.getCategories()
      ]);
      this.hideDropdown();
    },
    hideDropdown() {
      this.isVisible = false;
    }
  },
  mounted() {
    // Закрываем dropdown при клике вне компонента
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.isVisible = false;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.language-switcher {
  position: relative;
  display: inline-block;
  margin-left: 20px;

  @media screen and (max-width: 1280px) {
    display: none;
  }

  &__button {
    background: transparent;
    border: 1px solid #A5A5A5;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #A5A5A5;
    text-transform: uppercase;
    transition: all 0.2s;

    &:hover {
      border-color: #1F1F1F;
      color: #1F1F1F;
      background: transparent;
    }

    &:focus {
      outline: none;
      border-color: #1F1F1F;
      color: #1F1F1F;
    }
  }


  &__dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 4px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    list-style: none;
    padding: 4px 0;
    margin: 4px 0 0 0;
    min-width: 120px;
    z-index: 1000;
  }

  &__item {
    display: block;
    padding: 8px 16px;
    color: #333;
    text-decoration: none;
    transition: background 0.2s;
    font-size: 14px;

    &:hover {
      background: #f5f5f5;
    }

    &--active {
      background: #e7f3ff;
      font-weight: 500;
    }
  }
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>

